/* eslint-disable no-console */
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';

// ----- SUPPORTING DOCUMENTS METHODS ----- //
export const getSupportingDocuments = async (payload) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPORTING_DOCUMENTS.GET}`, {
      params: payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getMergedDocuments = async (payload) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPORTING_DOCUMENTS.MERGED_DOCS}`, {
      params: payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteMergedDocuments = async (payload) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SUPPORTING_DOCUMENTS.MERGED_DOCS}`, {
      params: payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const updateDocuments = async (payload) => {
  try {
    const params = new URLSearchParams(payload);
    return await apiClient.put(`${apiEndpoint}${API.SUPPORTING_DOCUMENTS.PUT}?${params}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const uploadDocuments = async (payload) => {
  try {
    if (payload && payload.documentType === 'link') {
      return await apiClient.post(`${apiEndpoint}${API.SUPPORTING_DOCUMENTS.POST_LINKS}`, payload);
    }
    return await apiClient.post(`${apiEndpoint}${API.SUPPORTING_DOCUMENTS.POST}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addToColourLib = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUPPORTING_DOCUMENTS.ADD_COLOUR_LIB}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteSupportingDocuments = async (payload) => {
  try {
    const params = new URLSearchParams(payload);
    return await apiClient.delete(`${apiEndpoint}${API.SUPPORTING_DOCUMENTS.DELETE}?${params}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteAllUnSavedSupportingDocuments = async () => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SUPPORTING_DOCUMENTS.REMOVE_ALL}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// ----- BOM SUPPORTING DOCUMENT MULTIPART/RESUME METHODS ----- //

/**
 * Persists a BOM supporting document whose bytes are already in S3 (uploaded via
 * the multipart/background engine).
 * @param {Object} payload - Document metadata plus the stored S3 key.
 * @returns {Promise<Object>} API response.
 */
export const saveBomSupportingDocFromS3 = async (payload) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.SUPPORTING_DOCUMENTS.SAVE_FROM_S3}`, payload);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

/**
 * Lists resumable BOM uploads for one context (a dev order or a BOM library),
 * scoped server-side to the logged-in user.
 * @param {Object} params - { devOrderId?, libId? }.
 * @returns {Promise<Object>} API response.
 */
export const getBomResumableUploads = async (params) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPORTING_DOCUMENTS.PENDING_UPLOADS_SCOPE}`, { params });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

/**
 * Lists every resumable BOM upload owned by the logged-in user across all scopes.
 * @returns {Promise<Object>} API response.
 */
export const getAllBomResumableUploads = async () => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPORTING_DOCUMENTS.PENDING_UPLOADS_ALL}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

/**
 * Fetches the resume state (uploadId + already-uploaded parts) for a BOM upload.
 * @param {string} taskId - Client task id of the pending upload.
 * @returns {Promise<Object>} API response.
 */
export const getBomUploadResumeState = async (taskId) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPORTING_DOCUMENTS.MULTIPART_BASE}/pending-uploads/${taskId}/resume-state`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

/**
 * Discards a resumable BOM upload the user chose not to resume.
 * @param {string} taskId - Client task id of the pending upload.
 * @returns {Promise<Object>} API response.
 */
export const discardBomResumableUpload = async (taskId) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.SUPPORTING_DOCUMENTS.MULTIPART_BASE}/pending-uploads/${taskId}`);
  } catch (error) {
    console.error(error);
    throw error;
  }
};
